const getPageOffset = (pageNumber: number, limit: number): number => {
    if (
        typeof pageNumber === "undefined" ||
        typeof limit === "undefined" ||
        limit < 1
    ) {
        return 0;
    }
    const offset = limit * (pageNumber - 1) + 1;
    return offset;
};

export default getPageOffset;
